<template>
  <td class="tags text-lowercase">
    <span>
      {{ tags | truncate(30, '...') }}
    </span>
  </td>
</template>

<script>
export default {
  name: 'Tags',
  props: {
    opt: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      tags: '',
    }
  },
  watch: {
    opt(data) {
      this.tags = data.item._MetaData.Tags.join(', ')
    },
  },
}
</script>

<style lang="scss" scoped>
.tags {
  position: relative;
}
</style>
